import { Link } from "react-router-dom";
import { ArrowUpRight, Linkedin, Youtube, Facebook, Instagram } from "lucide-react";
import "./Footer.css";
import DBLOGO from "./ui/db_logo.svg";
import LinkedinIcon from "./ui/linkedin.svg";
import FBIcon from "./ui/facebook.svg";
import InstaIcon from "./ui/insta.svg";
import youtubeIcon from './ui/youtube.svg'


export const Footer = () => {

    return (
        <footer
            data-testid="site-footer"
            className="footer-section"
        >
            <div className="container-db py-5">
                <div className="row g-5">
                    {/* Brand */}
                    <div className="col-12 col-md-5 d-flex flex-column">
                        <Link
                            to="/"
                            className="footer-desc text-decoration-none"
                            data-testid="footer-desc"
                        >
                            <img src={DBLOGO} className='footer-desc' alt="DB Productions" style={{ width: '70%', height: '70%', objectFit: 'contain', objectPosition: 'left' }} />
                        </Link>
                        <p className="footer-desc ">
                            Engineering immersive experiences, advanced defence-grade simulation systems, and cutting-edge technology solutions for over 30 years.

                        </p>
                        <div className="d-flex align-items-center gap-4 mt-5">
                            <a href="https://www.linkedin.com/company/db-productions-india/" target="_blank" rel="noreferrer" className="social-icon">
                                <img src={LinkedinIcon} alt="LinkedIn" />
                            </a>

                            <a href="https://www.youtube.com/channel/UCY3po4q5Ht3_ennigPlzpsw" target="_blank" rel="noreferrer" className="social-icon">
                                <img src={youtubeIcon} alt="YouTube" />
                            </a>

                            <a href="https://www.facebook.com/profile.php?id=61557963593438" target="_blank" rel="noreferrer" className="social-icon">
                                <img src={FBIcon} alt="Facebook" />
                            </a>

                            <a href="https://www.instagram.com/dbproductons_/" target="_blank" rel="noreferrer" className="social-icon">
                                <img src={InstaIcon} alt="Instagram" />
                            </a>
                        </div>
                    </div>

                    {/* Links */}
                    <div className="col-12 col-md-3">
                        <div className="font-mono-tech footer-title mb-4">
                            Navigate
                        </div>
                        <ul className="list-unstyled d-flex flex-column gap-2 m-0">
                            {[
                                ["/", "Home"],
                                ["/services", "Services"],
                                ["/defence", "Defence"],
                                ["/projects", "Projects"],
                                ["/videos", "Videos"],
                                ["/about", "About"],
                                ["/contact", "Contact"],
                            ].map(([to, label]) => (
                                <li key={to}>
                                    <Link
                                        to={to}
                                        data-testid={`footer-link-${label.toLowerCase()}`}
                                        className="footer-link text-decoration-none"
                                    >
                                        {label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Capabilities */}
                    <div className="col-12 col-md-4">
                        <div className="font-mono-tech footer-title mb-4">
                            Capabilities
                        </div>
                        <ul className="list-unstyled d-flex flex-column gap-2 m-0 text-muted-custom">
                            {[
                                ["/defence", "Defence Training"],
                                ["/services", "Immersive Experiences"],
                                ["/virtual-productions", "IntelliTrack"],
                                ["/immersive", "Interactive Exhibits"],
                                ["/about", "Indigenous Hardware"],
                                ["/services", "Deep Tech"],
                                ["/projects", "Virtual Production"],
                            ].map(([to, label]) => (
                                <li key={label}>
                                    <Link
                                        to={to}
                                        className="footer-link text-decoration-none text-muted-custom"
                                    >
                                        {label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className="footer-bottom mt-5 pt-4 d-flex align-items-center justify-content-center">
                    <p className="font-mono-tech footer-copyright m-0 text-center">
                        © 2026 DB Productions. All Rights Reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
};



export default Footer;
